import { initialDamagesClaimsValues } from '../../data/damages-claims-data';
import { IDamagesClaims } from '../../models/damages-claims/damages-claims.interface';
import { createStore } from '../store';

export const {
  Provider: ClaimsProvider,
  useStore,
  useSetStore
} = createStore<IDamagesClaims>(initialDamagesClaimsValues);
